import capabilities from '@/store/modules/sessionState/client/capabilities';

export default {
    capabilities,
};
